import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

// Base path
export const PATH_TAXES = "/member/taxes";

// Parameter constants
export const PARAMETER_PENDING_WITHHOLDING_ID = "pendingWithholdingId";

// Composed paths
export const PATH_TAXES_SENT_TO_IRS = `${PATH_TAXES}/sent-to-irs`;
export const PATH_TAXES_EDIT_TAX_RATE = `${PATH_TAXES}/edit/tax-rate`;
export const PATH_TAXES_EDIT_TAX_PROFILE = `${PATH_TAXES}/edit/tax-profile`;
export const PATH_TAXES_SURVEY = `${PATH_TAXES}/survey`;
export const PATH_TAXES_SCHEDULE_PAYMENT = `${PATH_TAXES}/schedule-payment`;
export const PATH_TAXES_SCHEDULE_PAYMENT_CONFIRMATION = `${PATH_TAXES_SCHEDULE_PAYMENT}/confirmation/:${PARAMETER_PENDING_WITHHOLDING_ID}`;

// Path helpers
export const routeTaxes = createRouteHelpers(PATH_TAXES);

export const routeHelpersTaxesSchedulePaymentConfirmation = createRouteHelpers(
  PATH_TAXES_SCHEDULE_PAYMENT_CONFIRMATION
);
